import React, { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  DatabaseOutlined,
  DeleteOutlined,
  FileTextOutlined,
  LogoutOutlined,
  StarOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Menu, Space } from "antd";
import { removeLocalStorageItem } from "@/Utils/Index";

function AdminNavigationMenu() {
  const navigate = useNavigate();

  const location = useLocation();
  const [selected, setSelected] = useState(location.pathname);

  const handleLogout = () => {
    removeLocalStorageItem("authorizationAdminPanel");
    navigate("/app/admin/login");
  };
  const menuItems = [
    {
      key: "/app/admin/user",
      icon: <UserOutlined />,
      label: "User",
    },
{
      key: "/app/admin/organization",
      icon: <TeamOutlined />,
      label: "Organization",
    },
    // {
    //   key: "/app/admin/deleteuser",
    //   icon: <DeleteOutlined />,
    //   label: "Deleted Users",
    // },
    {
      key: "/app/admin/getdata",
      icon: <DatabaseOutlined />,
      label: "GetData",
    },
    {
      key: "/app/admin/resumedata",
      icon: <FileTextOutlined />,
      label: "Resume Data",
    },
    {
      key: "/app/admin/reviews",
      icon: <StarOutlined />,
      label: "Reviews",
    },
    {
      type: "divider",
    },
    {
      key: "others",
      label: "Others",
      type: "group",
      children: [
        {
          key: "logout",
          icon: <LogoutOutlined />,
          label: "Logout",
          onClick: handleLogout,
        },
      ],
    },
  ];

  const handleMenuClick = useCallback(
    ({ key }) => {
      if (key !== "logout" && key !== "others") {
        navigate(key);
        setSelected(key);
      }
    },
    [navigate]
  );

  return (
    <Menu
      mode="inline"
      selectedKeys={[selected]}
      onClick={handleMenuClick}
      items={menuItems}
      style={{
        height: "100%",
        borderRight: 0,
      }}
    />
  );
}

export default AdminNavigationMenu;
